import { WheelField, WheelValue } from "../../../util/enums";

export const TIMES_TO_SPIN = 10;

export const wheelFields: WheelField[] = [
  {
      id: "1",
      value: WheelValue.SEVEN,
  },
  {
      id: "2",
      value: WheelValue.FIVE,
  },
  {
      id: "3",
      value: WheelValue.FIFTEEN,
  },
  {
      id: "4",
      value: WheelValue.THREE,
  },
  {
      id: "5",
      value: WheelValue.FIVE,
  },
  {
      id: "7",
      value: WheelValue.ONE,
  },
  {
      id: "6",
      value: WheelValue.TEN,
  },
  {
      id: "8",
      value: WheelValue.NINE,
  },
  {
      id: "9",
      value: WheelValue.EIGHT,
  },
  {
      id: "10",
      value: WheelValue.SEVEN,
  },
  {
      id: "11",
      value: WheelValue.FOUR,
  },
  {
      id: "12",
      value: WheelValue.NINE,
  },
  {
      id: "13",
      value: WheelValue.TEN,
  },
  {
      id: "14",
      value: WheelValue.TWO,
  },
  {
      id: "15",
      value: WheelValue.THREE,
  },
  {
      id: "16",
      value: WheelValue.SIX,
  },
];
